import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHelmet from '@/components/base/SEOHelmet';

export default function About() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '55漫画网',
      url: 'http://junyitea.cn/',
      description: '55漫画网是领先的免费漫画在线阅读平台，提供海量韩漫、日漫、国漫资源。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'hello@junyitea.cn',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: '首尔',
        addressRegion: '江南区',
        addressCountry: 'KR',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '关于我们 - 55漫画网',
      description: '了解55漫画网的品牌故事、平台成就和商务合作信息。专业的免费漫画在线阅读平台。',
      url: 'http://junyitea.cn/about',
      isPartOf: {
        '@type': 'WebSite',
        name: '55漫画网',
        url: 'http://junyitea.cn/',
      },
    },
  ];

  return (
    <>
      <SEOHelmet
        title="关于我们 - 品牌介绍 - 55漫画网"
        description="55漫画网品牌介绍，了解我们的故事、平台成就及商务合作信息。专业的免费漫画在线阅读平台，致力于为用户提供最优质的漫画阅读体验。"
        keywords="55漫画网, 关于我们, 漫画平台, 品牌介绍, 商务合作"
        canonicalUrl="http://junyitea.cn/about"
        jsonLd={jsonLd}
      />

      <Navbar />

      <main>
        <section className="pt-24 pb-10 md:pt-28 md:pb-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: '关于我们' },
              ]}
            />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mt-4">
              <div className="relative rounded-lg overflow-hidden h-64 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20creative%20office%20team%20working%20on%20digital%20content%2C%20Korean%20webtoon%20style%20illustrations%20on%20large%20screens%2C%20warm%20natural%20lighting%2C%20collaborative%20atmosphere%2C%20clean%20modern%20workspace%2C%20creative%20industry%20vibe%2C%20professional%20yet%20casual%20setting&width=800&height=500&seq=about-hero-001&orientation=landscape"
                  alt="55漫画网团队"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent flex items-center">
                  <div className="p-8">
                    <span className="text-xs text-background-50/80 mb-2 block">55漫画网</span>
                    <h1 className="text-3xl md:text-4xl font-heading font-bold text-background-50 leading-tight">
                      关于
                      <br />
                      我们
                    </h1>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                  让每个人都能
                  <br />
                  自由享受漫画之美
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  55漫画网成立于2023年，致力于打造一个高品质、免费的漫画阅读平台。我们相信，优秀的漫画作品应该被更多人看到，而不应被付费门槛所限制。通过技术创新和内容合作，我们为用户提供海量的漫画资源和流畅的阅读体验。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <span className="text-xs text-accent-500 font-medium tracking-wider uppercase">平台成就</span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
                我们的<span className="italic font-serif">影响力</span>数据
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-2xl mx-auto">
              <div className="relative p-8 rounded-lg bg-primary-500 text-background-50">
                <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20">
                  <i className="ri-arrow-right-up-line text-background-50"></i>
                </div>
                <p className="text-4xl font-heading font-bold">9.8</p>
                <p className="text-sm mt-2 opacity-90">用户平均评分</p>
                <p className="text-xs mt-3 opacity-70 italic">来自数十万读者真实评价</p>
              </div>

              <div className="relative p-8 rounded-lg bg-accent-500 text-background-50">
                <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20">
                  <i className="ri-arrow-right-up-line text-background-50"></i>
                </div>
                <p className="text-4xl font-heading font-bold">500+</p>
                <p className="text-sm mt-2 opacity-90">累计收录作品数</p>
                <p className="text-xs mt-3 opacity-70 italic">涵盖韩漫、日漫、国漫等多品类</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
              我们的服务
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  title: '海量漫画资源',
                  desc: '覆盖韩漫、日漫、国漫、美漫等多种类型，从经典名作到最新连载，应有尽有。',
                  icon: 'ri-stack-line',
                  primary: true,
                },
                {
                  title: '优质阅读体验',
                  desc: '高清画质、极速加载、智能推荐算法，为你打造沉浸式的漫画阅读体验。',
                  icon: 'ri-device-line',
                  primary: false,
                },
                {
                  title: '商务合作对接',
                  desc: '欢迎漫画作者和内容方与我们合作，共同为读者提供更多优质作品。',
                  icon: 'ri-team-line',
                  primary: false,
                },
              ].map((svc, i) => (
                <div key={i} className="p-6 rounded-lg bg-background-100 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                    <i className={`${svc.icon} text-2xl text-primary-500`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">{svc.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4">{svc.desc}</p>
                  {svc.primary ? (
                    <Link
                      to="/category/korean"
                      className="inline-flex px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                    >
                      浏览作品
                    </Link>
                  ) : (
                    <a
                      href="#contact"
                      className="inline-flex px-5 py-2 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:bg-background-200 transition-colors cursor-pointer"
                    >
                      了解更多
                    </a>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
              <div className="md:col-span-3">
                <div className="flex items-center gap-2 mb-6">
                  <span className="w-2 h-2 rounded-full bg-foreground-900"></span>
                  <h2 className="text-lg font-heading font-bold text-foreground-950">媒体评价</h2>
                </div>

                <div className="space-y-5">
                  {[
                    {
                      source: '动漫资讯网',
                      text: '« 55漫画网凭借丰富的资源和出色的用户体验，迅速成为国内领先的免费漫画阅读平台。其简洁的界面设计和智能推荐系统深受读者喜爱。 »',
                    },
                    {
                      source: '数字阅读周刊',
                      text: '« 在众多的漫画平台中，55漫画网以免费模式和高品质内容脱颖而出，为漫画爱好者提供了一个难得的阅读天堂。 »',
                    },
                    {
                      source: '创作者社区',
                      text: '« 作为漫画创作者，我们非常认可55漫画网为作者提供的展示平台。透明的数据反馈和友好的合作模式，让我们能更专注于创作。 »',
                    },
                  ].map((review, i) => (
                    <div key={i} className="p-5 rounded-lg bg-background-50">
                      <p className="text-sm text-foreground-600 leading-relaxed italic mb-3">{review.text}</p>
                      <span className="text-xs font-medium text-foreground-800">—— {review.source}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="md:col-span-2">
                <div className="rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20professional%20creative%20team%20portrait%20in%20modern%20office%20with%20Korean%20webtoon%20elements%20on%20walls%2C%20warm%20lighting%2C%20confident%20expressions%2C%20black%20and%20white%20with%20subtle%20warm%20tones%2C%20editorial%20style%2C%20clean%20composition&width=500&height=600&seq=about-review-001&orientation=portrait"
                    alt="55漫画网团队"
                    title="55漫画网团队"
                    className="w-full h-auto rounded-lg"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
              商务合作
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-10">
              欢迎漫画作者、出版社及内容合作方与我们联系
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
              {[
                { icon: 'ri-mail-line', label: '合作邮箱', value: 'hello@junyitea.cn' },
                { icon: 'ri-phone-line', label: '联系电话', value: '+82-2-1234-5678' },
                { icon: 'ri-map-pin-line', label: '公司地址', value: '韩国首尔市江南区' },
              ].map((item, i) => (
                <div key={i} className="p-5 rounded-lg bg-background-100 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                    <i className={`${item.icon} text-primary-500`}></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">{item.label}</p>
                  <p className="text-sm font-medium text-foreground-900">{item.value}</p>
                </div>
              ))}
            </div>

            <form className="bg-background-100 rounded-lg p-6 md:p-8 space-y-4" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                  <input
                    type="text"
                    name="name"
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="您的姓名"
                  />
                </div>
                <div>
                  <label className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="hello@junyitea.cn"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm text-foreground-700 mb-1.5">合作意向</label>
                <input
                  type="text"
                  name="subject"
                  className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请简要描述合作意向"
                />
              </div>
              <div>
                <label className="block text-sm text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请详细描述您的合作需求（最多500字）"
                ></textarea>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="visually-hidden"
              />
              <button
                type="submit"
                className="w-full py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                发送合作请求
              </button>
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}